import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { SectionD } from '../../oasis-sections/section-d';
import { OASIS } from '../../oasis-types';
import { isActive, isTimepoint } from '../util';
const consistency = (presence, frequency, type) => {
    if (type === 'a') {
        // (a) If X=[0], then Y must equal [0].
        if (presence === '0' && frequency !== '0') {
            return true;
        }
    }
    if (type === 'b') {
        // (b) If X=[1], then Y must equal [0,1,2,3].
        if (presence === '1' && (!frequency || (frequency && !['0', '1', '2', '3'].includes(frequency)))) {
            return true;
        }
    }
    if (type === 'c') {
        // (c) If X=[9,-], then Y must equal [^].
        if (presence && ['9', '-'].includes(presence) && frequency) {
            return true;
        }
    }
    return false;
};
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionDConsistency = ({ input, ctx, version, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    const payload = input;
    if (!isActive(SectionD.d0150, version, payload.SectionA?.m0100) || !isActive(SectionD.d0160, version, payload.SectionA?.m0100)) {
        return;
    }
    const d0150 = payload.SectionDE?.d0150;
    const d0160 = payload.SectionDE?.d0160;
    const presenceValues = [
        d0150?.c.presence,
        d0150?.d.presence,
        d0150?.e.presence,
        d0150?.f.presence,
        d0150?.g.presence,
        d0150?.h.presence,
        d0150?.i.presence,
    ];
    const frequencyValues = [
        d0150?.a.frequency,
        d0150?.b.frequency,
        d0150?.c.frequency,
        d0150?.d.frequency,
        d0150?.e.frequency,
        d0150?.f.frequency,
        d0150?.g.frequency,
        d0150?.h.frequency,
        d0150?.i.frequency,
    ];
    // D-consistency-5810 (a) If D0150A1=[0], then D0150A2 must equal [0].
    if (consistency(d0150?.a.presence, d0150?.a.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5810 (a) If D0150A1 = 0, then D0150A2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5810 (b) If D0150A1=[1], then D0150A2 must equal [0,1,2,3].
    if (consistency(d0150?.a.presence, d0150?.a.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5810 (b) If D0150A1 = 1, then D0150A2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5810 (c) If D0150A1=[9,-], then D0150A2 must equal [^].
    if (consistency(d0150?.a.presence, d0150?.a.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5810 (c) If D0150A1 = 9 or NA, then D0150A2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5820 (a) If D0150B1=[0], then D0150B2 must equal [0].
    if (consistency(d0150?.b.presence, d0150?.b.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5820 (a) If D0150B1 = 0, then D0150B2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5820 (b) If D0150B1=[1], then D0150B2 must equal [0,1,2,3].
    if (consistency(d0150?.b.presence, d0150?.b.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5820 (b) If D0150B1 = 1, then D0150B2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5820 (c) If D0150B1=[9,-], then D0150B2 must equal [^].
    if (consistency(d0150?.b.presence, d0150?.b.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5820 (c) If D0150B1 = 9 or NA, then D0150B2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5830 (a) If D0150C1=[0], then D0150C2 must equal [0].
    if (consistency(d0150?.c.presence, d0150?.c.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5830 (a) If D0150C1 = 0, then D0150C2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5830 (b) If D0150C1=[1], then D0150C2 must equal [0,1,2,3].
    if (consistency(d0150?.c.presence, d0150?.c.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5830 (b) If D0150C1 = 1, then D0150C2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5830 (c) If D0150C1=[9,-], then D0150C2 must equal [^].
    if (consistency(d0150?.c.presence, d0150?.c.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5830 (c) If D0150C1 = 9 or NA, then D0150C2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5840 (a) If D0150D1=[0], then D0150D2 must equal [0].
    if (consistency(d0150?.d.presence, d0150?.d.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5840 (a) If D0150D1 = 0, then D0150D2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5840 (b) If D0150D1=[1], then D0150D2 must equal [0,1,2,3].
    if (consistency(d0150?.d.presence, d0150?.d.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5840 (b) If D0150D1 = 1, then D0150D2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5840 (c) If D0150D1=[9,-], then D0150D2 must equal [^].
    if (consistency(d0150?.d.presence, d0150?.d.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5840 (c) If D0150D1 = 9 or NA, then D0150D2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5850 (a) If D0150E1=[0], then D0150E2 must equal [0].
    if (consistency(d0150?.e.presence, d0150?.e.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5850 (a) If D0150E1 = 0, then D0150E2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5850 (b) If D0150E1=[1], then D0150E2 must equal [0,1,2,3].
    if (consistency(d0150?.e.presence, d0150?.e.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5850 (b) If D0150E1 = 1, then D0150E2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5850 (c) If D0150E1=[9,-], then D0150E2 must equal [^].
    if (consistency(d0150?.e.presence, d0150?.e.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5850 (c) If D0150E1 = 9 or NA, then D0150E2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5860 (a) If D0150F1=[0], then D0150F2 must equal [0].
    if (consistency(d0150?.f.presence, d0150?.f.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5860 (a) If D0150F1 = 0, then D0150F2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5860 (b) If D0150F1=[1], then D0150F2 must equal [0,1,2,3].
    if (consistency(d0150?.f.presence, d0150?.f.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5860 (b) If D0150F1 = 1, then D0150F2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5860 (c) If D0150F1=[9,-], then D0150F2 must equal [^].
    if (consistency(d0150?.f.presence, d0150?.f.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5860 (c) If D0150F1 = 9 or NA, then D0150F2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5870 (a) If D0150G1=[0], then D0150G2 must equal [0].
    if (consistency(d0150?.g.presence, d0150?.g.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5870 (a) If D0150G1 = 0, then D0150G2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5870 (b) If D0150G1=[1], then D0150G2 must equal [0,1,2,3].
    if (consistency(d0150?.g.presence, d0150?.g.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5870 (b) If D0150G1 = 1, then D0150G2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5870 (c) If D0150G1=[9,-], then D0150G2 must equal [^].
    if (consistency(d0150?.g.presence, d0150?.g.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5870 (c) If D0150G1 = 9 or NA, then D0150G2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5880 (a) If D0150H1=[0], then D0150H2 must equal [0].
    if (consistency(d0150?.h.presence, d0150?.h.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5880 (a) If D0150H1 = 0, then D0150H2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5880 (b) If D0150H1=[1], then D0150H2 must equal [0,1,2,3].
    if (consistency(d0150?.h.presence, d0150?.h.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5880 (b) If D0150H1 = 1, then D0150H2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5880 (c) If D0150H1=[9,-], then D0150H2 must equal [^].
    if (consistency(d0150?.h.presence, d0150?.h.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5880 (c) If D0150H1 = 9 or NA, then D0150H2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5890 (a) If D0150I1=[0], then D0150I2 must equal [0].
    if (consistency(d0150?.i.presence, d0150?.i.frequency, 'a')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5890 (a) If D0150I1 = 0, then D0150I2 must be answered as 0.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5890 (b) If D0150I1=[1], then D0150I2 must equal [0,1,2,3].
    if (consistency(d0150?.i.presence, d0150?.i.frequency, 'b')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5890 (b) If D0150I1 = 1, then D0150I2 must equal 0, 1, 2, or 3.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5890 (c) If D0150I1=[9,-], then D0150I2 must equal [^].
    if (consistency(d0150?.i.presence, d0150?.i.frequency, 'c')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5890 (c) If D0150I1 = 9 or NA, then D0150I2 must be empty.',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5900 (a) If D0150A2 = [0,1] and D0150B2 = [0,1], then the following active items must equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
    if (d0150?.a.frequency &&
        ['0', '1'].includes(d0150?.a.frequency) &&
        d0150?.b.frequency &&
        ['0', '1'].includes(d0150?.b.frequency) &&
        presenceValues.some((item) => item)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5900 (a) If D0150A2 = 0 or 1 and D0150B2 = 0 or 1, then items from D0150C1 through D0150I1 must be empty',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5900 (b) If D0150A1 = [-] or D0150B1 = [-], then the following active items must not equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
    if (d0150?.a.presence === '-' && d0150?.b.presence === '-' && presenceValues.some((item) => !item)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5900 (b) If D0150A1 = NA and D0150B1 = NA, then items from D0150C1 through D0150I1 must NOT be empty',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5900 (c) If D0150A1 = [9] and D0150B1 = [9], then the following active items must equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
    if (d0150?.a.presence === '9' && d0150?.b.presence === '9' && presenceValues.some((item) => item)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5900 (c) If D0150A2 = 9 and D0150B2 = 9, then items from D0150C1 through D0150I1 must be empty',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5900 (d) If (D0150A2 = [^] and D0150B2 = [0,1]) OR (D0150A2 = [0,1] and D0150B2 = [^]), then the following active items must not equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
    if (!d0150?.a.frequency && d0150?.b.frequency && ['0', '1'].includes(d0150?.b.frequency) && presenceValues.some((item) => !item)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5900 (d) If D0150A2 is empty and D0150B2 = 0 or 1, then items from D0150C1 through D0150I1 must NOT be empty',
            path: ['SectionDE', 'd0150'],
        });
    }
    if (d0150?.a.frequency && ['0', '1'].includes(d0150?.a.frequency) && !d0150?.b.frequency && presenceValues.some((item) => !item)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5900 (d) If D0150A2 = 0 or 1 and D0150B2 is empty, then items from D0150C1 through D0150I1 must NOT be empty',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5900 (e) If D0150A2 = [2,3] or D0150B2 = [2,3], then the following active items must not equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
    if (d0150?.a.frequency &&
        ['2', '3'].includes(d0150?.a.frequency) &&
        d0150?.b.frequency &&
        ['2', '3'].includes(d0150?.b.frequency) &&
        presenceValues.some((item) => !item)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5900 (e) If D0150A2 = 2 or 3 and D0150B2 = 2 or 3, then items from D0150C1 through D0150I1 must NOT be empty',
            path: ['SectionDE', 'd0150'],
        });
    }
    // D-consistency-5910 Total Severity Score Calculation:
    // D-consistency-5910 (a) If D0150A1 = [9] and D0150B1 = [9], then D0160 must equal [^].
    if (d0150?.a.presence === '9' && d0150?.b.presence === '9' && d0160) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5910 (a) If D0150A1 = 9 and D0150B1 = 9, then D0160 must be empty.',
            path: ['SectionDE', 'd0160'],
        });
    }
    // D-consistency-5910 (b) If D0150A2 = [0,1] and D0150B2 = [0,1], then D0160 must equal the sum of the values from D0150A2 and D0150B2.
    if (d0150?.a.frequency && ['0', '1'].includes(d0150?.a.frequency) && d0150?.b.frequency && ['0', '1'].includes(d0150?.b.frequency)) {
        const frequencySum = Number(d0150?.a.frequency) + Number(d0150?.b.frequency);
        if (!d0160 || isNaN(Number(d0160)) || (d0160 && Number(d0160) !== frequencySum)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5910 (b) If D0150A2 = 0 or 1 and D0150B2 = 0 or 1, then D0160 must equal the sum of the values from D0150A2 and D0150B2.',
                path: ['SectionDE', 'd0160'],
            });
        }
    }
    else {
        // Otherwise, the PHQ-9 must be completed, and D0160 must equal the sum of the values of the following nine items: D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2, D0150I2 and Format Integer Items to nearest integer. These are referred to as the \"items in Column 2\", below.
        // The following rules explain how to compute the score that is placed in item D0160. These rules consider the \"number of missing items in Column 2\" which is the number of items in Column 2 that are skipped.
        const frequencySum = frequencyValues.reduce((acc, val) => {
            if (val && !isNaN(Number(val))) {
                return (acc += Number(val));
            }
            return acc;
        }, 0);
        // D-consistency-5910 (c) If the following items D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2, D0150I2 equal [0,1,2,3], then D0160 must equal the sum of these items.
        if (d0150?.a.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.a.frequency) &&
            d0150?.b.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.b.frequency) &&
            d0150?.c.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.c.frequency) &&
            d0150?.d.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.d.frequency) &&
            d0150?.e.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.e.frequency) &&
            d0150?.f.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.f.frequency) &&
            d0150?.g.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.g.frequency) &&
            d0150?.h.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.h.frequency) &&
            d0150?.i.frequency &&
            ['0', '1', '2', '3'].includes(d0150?.i.frequency)) {
            if (!d0160 || isNaN(Number(d0160)) || (d0160 && Number(d0160) !== frequencySum)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-5910 (c) If the following items D0150A2 through D0150I2 equal 0, 1, 2, or 3, then D0160 must equal the sum of these items.',
                    path: ['SectionDE', 'd0160'],
                });
            }
        }
        // D-consistency-5910 (d) If one of the following items: D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2, D0150I2 = [^], then D0160 must equal the sum of the remaining items times 9/8(1.125), rounded to the nearest integer.
        if (frequencyValues.filter((item) => !item).length === 1) {
            const frequencyComputation = Math.round((frequencySum * 9) / 8);
            if (!d0160 || isNaN(Number(d0160)) || (d0160 && Number(d0160) !== frequencyComputation)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-5910 (d) If one of the following items: D0150A2 through D0150I2 is empty, then D0160 must equal ${frequencyComputation}.`,
                    path: ['SectionDE', 'd0160'],
                });
            }
        }
        // D-consistency-5910 (e) If two of the following items: D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2, D0150I2 = [^], then D0160 must equal the sum of the remaining items times 9/7(1.286), rounded to the nearest integer.
        if (frequencyValues.filter((item) => !item).length === 2) {
            const frequencyComputation = Math.round((frequencySum * 9) / 7);
            if (!d0160 || isNaN(Number(d0160)) || (d0160 && Number(d0160) !== frequencyComputation)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-5910 (e) If two of the following items: D0150A2 through D0150I2 is empty, then D0160 must equal ${frequencyComputation}.`,
                    path: ['SectionDE', 'd0160'],
                });
            }
        }
        // D-consistency-5910 (f) If three or more items between D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2 and D0150I2 = [^], then D0160 must equal [99].
        if (d0150?.a.presence !== '9' && d0150?.b.presence !== '9' && frequencyValues.filter((item) => !item).length >= 3) {
            if ((!d0160 || d0160 !== '99') && isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload?.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-5910 (f) If three or more items between D0150A2 through D0150I2 is empty, then D0160 must equal 99.',
                    path: ['SectionDE', 'd0160'],
                });
            }
        }
    }
};
// D-consistency-5810
// (a) If D0150A1=[0], then D0150A2 must equal [0].
// (b) If D0150A1=[1], then D0150A2 must equal [0,1,2,3].
// (c) If D0150A1=[9,-], then D0150A2 must equal [^].
// D-consistency-5900
// (a) If D0150A2 = [0,1] and D0150B2 = [0,1], then the following active items must equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
// (b) If D0150A1 = [-] or D0150B1 = [-], then the following active items must not equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
// (c) If D0150A1 = [9] and D0150B1 = [9], then the following active items must equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
// (d) If (D0150A2 = [^] and D0150B2 = [0,1]) OR (D0150A2 = [0,1] and D0150B2 = [^]), then the following active items must not equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
// (e) If D0150A2 = [2,3] or D0150B2 = [2,3], then the following active items must not equal [^]: D0150C1, D0150D1, D0150E1, D0150F1, D0150G1, D0150H1, D0150I1.
// D-consistency-5910 Total Severity Score Calculation:
// (a) If D0150A1 = [9] and D0150B1 = [9], then D0160 must equal [^].
// (b) If D0150A2 = [0,1] and D0150B2 = [0,1], then D0160 must equal the sum of the values from D0150A2 and D0150B2.
// Otherwise, the PHQ-9 must be completed, and D0160 must equal the sum of the values of the following nine items: D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2, D0150I2 and Format Integer Items to nearest integer. These are referred to as the \"items in Column 2\", below.
// The following rules explain how to compute the score that is placed in item D0160. These rules consider the \"number of missing items in Column 2\" which is the number of items in Column 2 that are skipped.
// (c) If the following items D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2, D0150I2 equal [0,1,2,3], then D0160 must equal the sum of these items.
// (d) If one of the following items: D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2, D0150I2 = [^], then D0160 must equal the sum of the remaining items times 9/8(1.125), rounded to the nearest integer.
// (e) If two of the following items: D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2, D0150I2 = [^], then D0160 must equal the sum of the remaining items times 9/7(1.286), rounded to the nearest integer.
// (f) If three or more items between D0150A2, D0150B2, D0150C2, D0150D2, D0150E2, D0150F2, D0150G2, D0150H2 and D0150I2 = [^], then D0160 must equal [99].
// D-consistency-5820
// (a) If D0150B1=[0], then D0150B2 must equal [0].
// (b) If D0150B1=[1], then D0150B2 must equal [0,1,2,3].
// (c) If D0150B1=[9,-], then D0150B2 must equal [^].
// D-consistency-5830
// (a) If D0150C1=[0], then D0150C2 must equal [0].
// (b) If D0150C1=[1], then D0150C2 must equal [0,1,2,3].
// (c) If D0150C1=[9,^,-], then D0150C2 must equal [^].
// D-consistency-5840
// (a) If D0150D1=[0], then D0150D2 must equal [0].
// (b) If D0150D1=[1], then D0150D2 must equal [0,1,2,3].
// (c) If D0150D1=[9,^,-], then D0150D2 must equal [^].
// D-consistency-5850
// (a) If D0150E1=[0], then D0150E2 must equal [0].
// (b) If D0150E1=[1], then D0150E2 must equal [0,1,2,3].
// (c) If D0150E1=[9,^,-], then D0150E2 must equal [^].
// D-consistency-5860
// (a) If D0150F1=[0], then D0150F2 must equal [0].
// (b) If D0150F1=[1], then D0150F2 must equal [0,1,2,3].
// (c) If D0150F1=[9,^,-], then D0150F2 must equal [^].
// D-consistency-5870
// (a) If D0150G1=[0], then D0150G2 must equal [0].
// (b) If D0150G1=[1], then D0150G2 must equal [0,1,2,3].
// (c) If D0150G1=[9,^,-], then D0150G2 must equal [^].
// D-consistency-5880
// (a) If D0150H1=[0], then D0150H2 must equal [0].
// (b) If D0150H1=[1], then D0150H2 must equal [0,1,2,3].
// (c) If D0150H1=[9,^,-], then D0150H2 must equal [^].
// D-consistency-5890
// (a) If D0150I1=[0], then D0150I2 must equal [0].
// (b) If D0150I1=[1], then D0150I2 must equal [0,1,2,3].
// (c) If D0150I1=[9,^,-], then D0150I2 must equal [^].
